<script>
import base from '@/views/config/addon-cards/templates/base.vue';
import CMRCommon from './mixin';
import { mapState } from 'vuex';
import { filter, get, orderBy } from 'lodash';
import { planTypes } from '@/common/constants';
import { isZoomMeetingAsAddonCard } from '@/plans/ZOOM_MEETING/common/utils';

export default {
  mixins: [base, CMRCommon],
  for: ()=> { 
      const shouldHide = isZoomMeetingAsAddonCard();
      if(shouldHide) return [];
      return planTypes.map([planTypes.VIDEO_SDK]);
  },
  created() {
    const { amount } = this.lowestPlan;
    this.subtitle = this.$t('billing.common.form_xx_month', [this.$money(amount)]);
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    lowestPlan() {
      const list = orderBy(
        filter(this.planMapFlat, (p) => p.type === planTypes.LDKCMR),
        ['capacity'],
        'asc',
      );
      return get(list, [0], {});
    },
  },
};
</script>
